// global-styles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

  body {
    font-family: 'Source Sans Pro', sans-serif !important;
    font-size: 13px;
    background-color:#012293;
    background-color: rgba(245,248,250);
    @font-face {
      font-family: 'Source Sans Pro', sans-serif !important;
      src: url('https://fonts.googleapis.com/css?family=Nunito|Source Sans Pro');
   };

      @font-face {
        font-family: 'Source Sans Pro', sans-serif;
        src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300&display=swap');
    };
    font-family: 'Source Sans Pro', sans-serif;
  }

  #root {
    font-family: 'Source Sans Pro', sans-serif !important;
    @font-face {
      font-family: 'Source Sans Pro', sans-serif !important;
      src: url('https://fonts.googleapis.com/css?family=Nunito|Source Sans Pro');
   };

          @font-face {
            font-family: 'Source Sans Pro', sans-serif;
            src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300&display=swap');
        };
      font-family: 'Source Sans Pro', sans-serif;
  }

  .SavedAuthors {
    min-height: 300px;
    background-color: #fff;
    border: solid 1px #dedede;
    margin-bottom: 18px;
    padding-bottom: 16px;
    padding: 16px;
    border-radius: 6px;
 }
  .SavedAuthors--heading {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 13px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000;
    padding: 6px;
 }
  .SavedAuthors--author-name {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000;
    margin-top: 0px;
 }
  .SavedAuthors--author-affiliation {
    width: 224px;
    height: 19px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000;
 }
  .SavedAuthors--save-btn {
    width: 96px;
    height: 37px;
    border-radius: 5px;
    background-color: #61d858;
    border: solid 1px #d8d8d8;
    color: white;
 }
  .SavedAuthors--cancel-btn {
    width: 96px;
    height: 37px;
    border-radius: 5px;
    background-color: #d0021b;
    border: solid 1px #d8d8d8;
    color: white;
    margin-left: 10px;
 }
  .SavedAuthors--author-country {
    width: 64px;
    height: 19px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000;
 }
  .SavedAuthors--remove-btn {
    width: 45px;
    height: 16px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a90e2;
    color: var(--dark-sky-blue);
    cursor: pointer;
 }
  .selectRadio {
    border: 2px solid gray;
    width: 15px;
    height: 15px;
    display: inline-block;
    cursor: pointer;
    border-radius: 100%;
 }

 .newAuthorProfile {
  background-color: #f7f8fa;
  padding: 20px;
  padding-top: 100px;
  text-align: center; 
}

.newAuthorProfile--Credentials {
  margin-bottom: 20px;
}

.ProfileNavBar {

  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #dedede;
  margin-bottom: 18px;
  padding-bottom: 10px;
}

.ProfileNavBar--back-to-results {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
  

.authorProfile--box {
  background-color: white;
  margin: auto;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  width: 90vw;
  margin-top: -10vh;
  min-height: 70vh;
  padding: 10px;
  margin-bottom: 50px;
}

.Credentials {
  min-height: 210px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #dedede;
  padding: 24px;
  text-align: left;
}

.Credentials--name {

  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Credentials--info {

  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Credentials--place {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Credentials--country {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a90e2;
}

.Credentials--city {
  font-family: 'Source Sans Pro', sans-serif;;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  }


  .footer {
    background-color: #f7f8fa;   
    border-top: 1px solid rgba(0,0,0,.1);
    margin-top: 0px;
    padding-top: 10px;
    text-align: center;
    width: 100vw;
    bottom: 0;
}

.footer-brandIcon {
  font-weight: 600;
  display:inline-block;
  text-align: center;
  font-size: 1.2em;
  color: #162556 
}

.footer--socialIcons {
  a {
    padding:3px;
  }
  svg {
    fill: #000;
    opacity: .5;
    transition: opacity .3s ease;
  }
}

.footer-subInfo {
  font-size: 0.8em;
  color: rgba(0,0,0,.3);
  font-weight: 600;
  margin-left: 10px;
}



.footer-copyright {
  font-size: 12px;
  color: rgba(0,0,0,.54);
}

.dummy_page {
    height: 200px;
    width: 100%;
    background-color: #f0f0f0;
    text-align: center;
    box-sizing: border-box;
    padding: 60px 0px;
  }
  
  .react-autosuggest__input {
    font-family: 'Source Sans Pro', sans-serif;
    border-radius: 4px;
    background-color: #f7f8fa;
    border: solid 1px #ebebeb;
    padding-left: 80px;
  }

  .react-autosuggest__suggestions-container--open {
    font-family: 'Source Sans Pro', sans-serif;
    border-radius: 4px;
    background-color: #f7f8fa;
    border: solid 1px #ebebeb;
  }

@media only screen and (max-width: 767px) {
  .react-autosuggest__input {
    font-family: 'Source Sans Pro', sans-serif;
    border-radius: 4px;
    background-color: white;
    padding-left: 20px;
    color: #969696;
    border: solid 1px #b2b2b2;
  }
}

.DownloadAsPDF--btn {
  width: 157px;
  height: 37px;
  border-radius: 5px;
  background-color: #4a90e2;
  background-color: var(--dark-sky-blue);
  border: solid 1px #d8d8d8;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.NewHome {
    min-height: 100vh;
    background-image: linear-gradient(to bottom, #eeeeee, #f3fbfe);
    box-shadow: 0 0 114px 0 rgba(0, 0, 0, 0.03);
}

.NewHome--search-wrapper {
    border-radius: 4px;
    box-shadow: 0 22px 24px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    border: solid 1px #dedede;
  
}


@import url('https://fonts.googleapis.com/css?family=Nunito|Source Sans Pro');
 @import url('https://fonts.googleapis.com/css?family=Raleway');
 @import url('https://fonts.googleapis.com/css?family=Roboto');
 body {
	 font-family: 'Source Sans Pro', sans-serif !important;
	 overflow-x: hidden;
}
 .loader-60devs .loader-60devs-progress {
	 background: #f73859;
	 height: 6px;
}
 .navbar-default .navbar-nav > li > a {
	 color: #fff;
}
 .react-tabs__tab-list li {
	 border-bottom: 1px solid transparent !important;
}
 blockquote {
	 border-left: none;
}
 .s-alert-top-right {
	 top: 60px !important;
	 right: 20px !important;
}
 .pagination > .active > a, .pagination > .active > a:focus, .pagination > .active > a:hover, .pagination > .active > span, .pagination > .active > span:focus, .pagination > .active > span:hover {
	 z-index: 3;
	 color: #fff;
	 cursor: default;
	 background-color: #162556;
	 border-color: #162556;
}
 .pagination > li > a, .pagination > li > span {
	 position: relative;
	 float: left;
	 padding: 6px 12px;
	 margin-left: -1px;
	 line-height: 1.42857143;
	 color: #162556;
	 text-decoration: none;
	 background-color: #fff;
	 border: 1px solid #ddd;
}
 .input-box-outer-card {
	 padding: 20px;
}
 .sideBar {
	 color: rgba(0, 0, 0, 0.87);
	 background-color: #fff;
	 transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
	 box-sizing: border-box;
	 -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	 box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
	 border-radius: 2px;
	 z-index: 1;
}
 .resultCard {
	 padding: 10px;
	 color: rgba(0, 0, 0, 0.87);
	 background-color: #fff;
	 transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
	 box-sizing: border-box;
	 -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	 border-radius: 2px;
	 z-index: 1;
	 margin-bottom: 20px;
	 min-height: 54vh;
}
 .table-bordered > tbody > tr > td, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > td, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > thead > tr > th {
	 border: 0px solid white !important;
}
 .feedbackInfo {
	 position: fixed;
	 display: inline-block;
	 background-color: #162556;
	 z-index: 1000;
	 bottom: 25px;
	 right: 100px;
	 padding: 8px;
	 color: white;
}
 .lds-dual-ring {
	 display: inline-block;
	 width: 20px;
	 height: 20px;
}
 .lds-dual-ring:after {
	 content: " ";
	 display: block;
	 width: 20px;
	 height: 20px;
	 margin: 1px;
	 border-radius: 50%;
	 border: 5px solid #fff;
	 border-color: #ece7e7 transparent #ece7e7 transparent;
	 animation: lds-dual-ring 1.2s linear infinite;
}
 @keyframes lds-dual-ring {
	 0% {
		 transform: rotate(0deg);
	}
	 100% {
		 transform: rotate(360deg);
	}
}
 .react-bs-table {
	 box-shadow: 0px 20px 10px white, -2px 2px 30px 10px rgba(183, 167, 167, 0.19);
	 margin-bottom: 40px;
}
 .allResult--tableRow > td {
	 padding: 15px !important;
}
 .table-hover > tbody > tr:hover {
	 background-color: white;
	 border-left: 5px solid #03248f;
	 box-shadow: 0px 20px 10px #fff, -2px -1px 20px 10px rgba(183, 167, 167, 0.19);
	 box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	 cursor: pointer;
}
 .tableHeaderStyle {
	 cursor: pointer;
	 padding: 10px;
	 text-transform: uppercase;
	 font-size: 0.9em;
	 color: #363434;
}
 .select-custom {
	 border-radius: 50px !important;
	 background-color: #fafafa;
	 border: none;
}
 .btn-info {
	 color: #fff;
	 background-color: #00c8ff;
	 border-color: #fff;
	 border-radius: 29px;
	 font-weight: bold;
}
 .react-date-picker__button {
	 display: flex;
	 background-color: gray;
	 border-radius: 30px;
	 padding: 4px;
	 background-color: #fafafa;
	 border: none !important;
}
 .react-autosuggest__container {
	 position: relative;
}
 .react-autosuggest__input {
	 width: 100%;
	 height: 50px;
	 padding: 10px 20px;
	 font-family: Helvetica, sans-serif;
	 font-weight: 300;
	 font-size: 16px;
	 border: 1px solid #aaa;
	 border-radius: 4px;
}
 .react-autosuggest__input--focused {
	 outline: none;
}
 .react-autosuggest__input--open {
	 border-bottom-left-radius: 0;
	 border-bottom-right-radius: 0;
}
 .react-autosuggest__suggestions-container {
	 display: none;
}
 .react-autosuggest__suggestions-container--open {
	 display: block;
	 position: absolute;
	 top: 51px;
	 width: 100%;
	 border: 1px solid #aaa;
	 background-color: #fff;
	 font-family: Helvetica, sans-serif;
	 font-weight: 300;
	 font-size: 16px;
	 border-bottom-left-radius: 4px;
	 border-bottom-right-radius: 4px;
	 z-index: 2;
}
 .react-autosuggest__suggestions-list {
	 margin: 0;
	 padding: 0;
	 list-style-type: none;
}
 .react-autosuggest__suggestion {
	 cursor: pointer;
   padding: 10px 50px;
}
 .react-autosuggest__suggestion--highlighted {
	 background-color: #ddd;
}
 .react-autosuggest__suggestion-match {
	 color: red;
	 font-weight: bold;
}
 .links line {
	 stroke: #999;
	 stroke-opacity: 0.6;
}
 .nodes circle {
	 stroke: #fff;
	 stroke-width: 1.5px;
}
 .vh-100 {
	 width: 100%;
	 height: 80vh;
}
 


`;

export default GlobalStyles;
